import WIDGET_ITEMS_MAP from '../items/widgets';
import { $fm } from '@/Intl';
import { TItem } from '@/components/GridBoards/types';
import { getArea } from '../doWithSider';

const createWidget = (
  props: {
    className: string;
    x?: number;
    y?: number;
  },
  product: Product = 'gxv3370',
  siderbounds: LayoutBoxSiderbounds,
): TItem => {
  const WIDGET_ITEMS = WIDGET_ITEMS_MAP[product];
  const id = props.className as keyof typeof WIDGET_ITEMS;
  const title = WIDGET_ITEMS[id].title;
  const img = WIDGET_ITEMS[id].img;
  const imgMini = WIDGET_ITEMS[id].imgMini;
  const size = WIDGET_ITEMS[id].size;
  const widgetClass = id.match(/\.([^.]+)$/)![1];
  return {
    id,
    x: props.x ?? -1,
    y: props.y ?? -1,
    w: size.w,
    h: size.h,
    isWidget: true,
    repeat: true,
    area: getArea(siderbounds),
    render: () => {
      return (
        <div className={`layout-widget widget-${widgetClass}`}>
          <img
            src={img}
            alt={title}
            draggable={false}
            className={`img-${widgetClass}`}
          />
          <span>{$fm(title)}</span>
        </div>
      );
    },
    renderPick: () => {
      return (
        <div className={`layout-pick-widget`}>
          <img
            src={imgMini}
            alt={title}
            draggable={false}
            className={`img-${widgetClass}`}
          />
          <span>
            {$fm(title)}
            <br />
            {`( ${size.w} × ${size.h} )`}
          </span>
        </div>
      );
    },
  };
};

export default createWidget;
